module.exports = __webpack_public_path__ + "img/cleaning_services-400x300.b735d7e3.jpg";